import { render, staticRenderFns } from "./agreeDialog.vue?vue&type=template&id=35ae1294&scoped=true"
import script from "./agreeDialog.vue?vue&type=script&lang=js"
export * from "./agreeDialog.vue?vue&type=script&lang=js"
import style0 from "./agreeDialog.vue?vue&type=style&index=0&id=35ae1294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae1294",
  null
  
)

export default component.exports